import { combineReducers } from 'redux';
import auth from './auth';
import settings from './settings';
import gallery from './gallery';
import list from './list';
import core from './core';
import wizard from './wizard';

export default combineReducers({
  auth,
  settings,
  gallery,
  list,
  core,
  wizard
});
